import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import {teams} from "./team.reducers";

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  teams,
  alert
});

export default rootReducer;
